import React from 'react'
import { Text, Stack, Button, Grid, GridItem, VStack } from '@chakra-ui/react'

import { Quiz, Stats } from 'types/generated/graphql'
import { LayoutEmbedQuiz } from 'components/Common/LayoutEmbedQuiz'

export interface QuizProps {
  quiz: Quiz
  quizOptions: string[]
  quizStats?: Stats
  onNext: () => void
  onSelectedChoice: (selectedChoice: string) => void
}

export const MultipleChoiceEmbedPlayQuestion: React.FC<QuizProps> = ({
  quiz,
  quizOptions,
  quizStats,
  onNext,
  onSelectedChoice,
}) => {
  return (
    <LayoutEmbedQuiz quiz={quiz} imageUrl={quiz.content.imageUrl!}>
      <VStack w="100%" spacing={3}>
        <Text fontSize={{ base: 'md', sm: 'lg' }} mb="1rem" color="white">
          Q：{quiz.content.question}
          {quizStats &&
            // statsには[正解、不正解1、不正解2…]の順番で入る
            `(正答率${quizStats.stats[0].percent})`}
        </Text>

        <Stack w="100%" spacing={4} direction="row" align="center">
          <Grid
            w="100%"
            templateRows={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
            templateColumns={{
              base: 'repeat(1, 1fr)',
              md: 'repeat(4, 1fr)',
            }}
            gap={4}
          >
            {quizOptions.map((quiz, index) => {
              if (!quiz) {
                return null
              }
              return (
                <GridItem
                  w="100%"
                  rowSpan={{ base: 1, md: 1 }}
                  colSpan={{ base: 1, md: 2 }}
                  colorscheme="teal"
                  key={quiz + index}
                >
                  <Button
                    size="lg"
                    w="100%"
                    onClick={() => {
                      onNext()
                      onSelectedChoice(quiz)
                    }}
                    bg="whiteAlpha.800"
                  >
                    {quiz}
                  </Button>
                </GridItem>
              )
            })}
          </Grid>
        </Stack>
      </VStack>
    </LayoutEmbedQuiz>
  )
}
